import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { login, loginWithPassword } from "../Actions/Auth";

const initialState = {
  isLoading: false,
  has_password: false,
  message: "",
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.message = "Loging in";
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.message = "Log in successfully";
        state.has_password = action.payload.data.data.has_password;
        localStorage.setItem(
          `${process.env.REACT_APP_PREFIX}_access_token`,
          action.payload.data.data.access_token
        );
        localStorage.setItem(
          `${process.env.REACT_APP_PREFIX}_refresh_token`,
          action.payload.data.data.refresh_token
        );
        // if (!action.payload.data.data.has_password) {
        //   message.success("Login successfully");
        //   setTimeout(() => {
        //     window.location.href = `/reset-password`;
        //   }, 1000);
        // } else {
        message.success("Login successfully");
        setTimeout(() => {
          window.location.href =
            window.location.pathname === "/login"
              ? window.history.state.usr?.previousPage ?? "/"
              : `${window.location.pathname}${window.location.search}`;
        }, 1000);
        // }
      })
      .addCase(login.rejected, (state) => {
        state.isLoading = false;
        state.message = "The username or password is wrong. Please check";
      });
    builder
      .addCase(loginWithPassword.pending, (state) => {
        state.isLoading = true;
        state.message = "Loging in";
      })
      .addCase(loginWithPassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.message = "Log in successfully";
        state.has_password = true;
        localStorage.setItem(
          `${process.env.REACT_APP_PREFIX}_access_token`,
          action.payload.data.access_token
        );
        localStorage.setItem(
          `${process.env.REACT_APP_PREFIX}_refresh_token`,
          action.payload.data.refresh_token
        );
        message.success("Login successfully");
        setTimeout(() => {
          window.location.href =
            window.location.pathname === "/login"
              ? window.history.state.usr?.previousPage ?? "/"
              : `${window.location.pathname}${window.location.search}`;
        }, 1000);
      })
      .addCase(loginWithPassword.rejected, (state) => {
        state.isLoading = false;
        state.message = "The username or password is wrong. Please check";
        message.error("The username or password is wrong. Please check");
      });
  },
});
export default authSlice.reducer;
